export const WORKING_HOUR_URL = "/v1/appointment/business/site/working-hour";

export const URL_LIST_BLOCK_TIME = "/v1/appointment/appointment/business-time-off/list?";

export const URL_GET_BUSINESS_TIME_OFF = "/v1/appointment/appointment/business-time-off/get?";

export const URL_CREATE_BUSINESS_TIME_OFF = "/v1/appointment/appointment/business-time-off/create";

export const URL_UPDATE_BUSINESS_TIME_OFF = "/v1/appointment/appointment/business-time-off/update";

export const URL_DELETE_BUSINESS_TIME_OFF = "/v1/appointment/appointment/business-time-off/delete";
